import $ from 'jquery'; // Features

;
import '../../features/videos/blocks/video-grid/video-grid.js'; import '../../features/videos/videos.js';
import hide_on_scroll from './modules/hide-on-scroll';
$(function () {
  /*
   * Fix mobile menu modal for anchor links
   */
  // TODO: make this only apply to links that have a hash!
  // $('nav.is-responsive a').on('click', function(e) {
  //   const $container = $(e.currentTarget).closest('.wp-block-navigation__responsive-container');
  //   console.log($container);
  //   $container.removeClass('is-menu-open has-modal-open');
  //   $('html').removeClass('has-modal-open');
  // });
  // TODO: only apply hide on scroll on specific breakpoints
  var $toggle = $('.NavMobile .wp-block-navigation__responsive-container-open');
  hide_on_scroll($toggle);
  /*
  * Apply has-value attributes on form fields
  */

  var $forms = $('.wpcf7-form, .AlistSubscribeForm');
  var $inputs = $('.wpcf7-form-control, .AlistSubscribeForm-input');
  var fieldWrapper = '.field-wrapper'; // set data-focussed based on focus/blur state

  $inputs.on('focus blur', function (e) {
    $(this).closest(fieldWrapper).attr('data-focused', e.type == 'focus');
  });
  $inputs.on('blur', function (e) {
    var $input = $(this);
    var hasValue = $input.val() != undefined && $input.val() != '';
    $input.closest(fieldWrapper).attr('data-has-value', hasValue);
  });
  $forms.on('reset', function (e) {
    var $form = $(e.currentTarget);
    $form.find(':focus').trigger('blur');
    $form.find('[data-has-value="true"]').attr('data-has-value', false);
  });
});